import { createLayout } from "@/layout/layout";
import { createAuthDialog } from "@/components/auth/auth-dialog/auth-dialog";
import { createSocialAuth } from "@/components/auth/social-auth";
import { createHeader } from "@/components/header/header";
import { deprecated_createTurnstile } from "@/utils/cloudflare/turnstile";
import { createScrollToTarget } from "@/utils/scroll";
import { CustomModal } from "@/deprecated/custom-modal/custom-modal";
import "./front.css";

export const createFrontLayout = () => {
  createLayout();
  createHeader();
  createScrollToTarget();
  createAuthModals();

  window.CustomModal = CustomModal;
};

const createAuthModals = () => {
  const login = CustomModal.create("login-modal");
  const register = CustomModal.create("register-modal");
  const recovery = CustomModal.create("password-recovery");

  login.on("open", () => {
    deprecated_createTurnstile(
      `[data-custom-modal="login-modal"] .cf-turnstile`,
    );
  });

  register.on("open", () => {
    deprecated_createTurnstile(
      `[data-custom-modal="register-modal"] .cf-turnstile`,
    );
  });

  recovery.on("open", () => {
    deprecated_createTurnstile(
      `[data-custom-modal="password-recovery"] .cf-turnstile`,
    );
  });

  createSocialAuth(
    [
      `[data-custom-modal="login-modal"] .modal-auth-buttons .btn`,
      `[data-custom-modal="register-modal"] .modal-auth-buttons .btn`,
      `[data-custom-modal="password-recovery"] .modal-auth-buttons .btn`,
    ].join(", "),
  );

  document
    .querySelector(`[href="/sign-in"]`)
    ?.addEventListener("click", (event) => {
      event.preventDefault();
      createAuthDialog({
        view: "sign-in",
      });
    });
  document
    .querySelector(`[href="/sign-up"]`)
    ?.addEventListener("click", (event) => {
      event.preventDefault();
      createAuthDialog({
        view: "sign-up",
      });
    });
};
